import React from 'react'

import { cn } from '../../../../../../lib/utils'

import animate from '../../../../../styles/animations.module.css'
import { DefaultMessageProps } from '..'
import Link from 'next/link'
import { Button } from '../../../../Button'

export type ContentMessageProps = {
  id: string
  text: string
  contentURL: string
  title?: string
  header?: string
  handleViewContent: () => void | Promise<void>
}

export const ContentMessage = (
  props: ContentMessageProps & DefaultMessageProps,
) => {
  const {
    id,
    text,
    relativeTime,
    author,
    isMine,
    isNewChatMessage,
    title,
    header,
    error,
    handleViewContent,
  } = props

  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center min-w-[50px] break-words md:max-w-[500px] max-w-4/5',
        animate.smallTransitionIn,
        {
          [animate.expandAnimation as string]: isNewChatMessage,
        },
      )}
      title={`message-${title}-${id}`}
    >
      <div className="flex items-center justify-between w-full gap-2">
        <div className="flex items-center">
          {author.href ? (
            <Link
              className="ml-1 text-sm hover:underline underline-offset-2 hover:opacity-80"
              title={`message-${title}-${id}-name`}
              href={author.href}
            >
              {author.name}
            </Link>
          ) : (
            <button
              className="ml-1 text-sm hover:underline underline-offset-2 hover:opacity-80"
              title={`message-${title}-${id}-name`}
              onClick={author.handleClick}
            >
              {author.name}
            </button>
          )}
        </div>
        <div
          className="text-xs text-accent-foreground/40"
          title={`message-${title}-${id}-createdAt`}
        >
          {relativeTime}
        </div>
      </div>

      <div
        className={cn(
          'relative w-full rounded-xl bg-border px-4 py-2 bg-accent text-foreground text-sm break-words',
          {
            'bg-message-background-gradient bg-message-background text-white whitespace-pre-line':
              isMine == true,
          },
        )}
        title={`message-${title}-${id}-text`}
      >
        {header && <div className="font-bold">{header}</div>}
        <span>{text}</span>
        <div className="mt-3">
          <Button
            variant="outline"
            label="View Content"
            handleClick={handleViewContent}
            className="w-full"
          />
        </div>
      </div>

      {error && (
        <div className="w-full text-xs text-destructive">
          {error.label}{' '}
          {error.action && (
            <button
              className="font-bold hover:underline ml-2"
              onClick={error.action?.handleClick}
            >
              {error.action.label}
            </button>
          )}
        </div>
      )}
    </div>
  )
}
